import React from "react"
import styles from "./styles.module.scss"

interface PaymentMethodProps {
  title: string
  description: string
  amount: string
  isSelected: boolean
  onPress: () => void
  paymentMethodDetails?: React.ReactNode
}

export const PaymentMethod: React.FC<PaymentMethodProps> = ({
  title,
  description,
  amount,
  isSelected,
  onPress,
  paymentMethodDetails,
}) => {
  return (
    <div
      className={`${styles.container} ${isSelected ? styles.selected : ""}`}
      onClick={onPress}
      role="button"
      tabIndex={0}
    >
      <div className={styles.content}>
        <p className={styles.title}>{title}</p>
        <p className={styles.description}>{description}</p>
        {isSelected && paymentMethodDetails && (
          <div className={styles.details}>{paymentMethodDetails}</div>
        )}
        <p className={styles.amount}>{amount}</p>
      </div>
    </div>
  )
}
